import { Space, Button, Row, Col, Descriptions, Table } from 'antd';
import { EditFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Users.css';
// import { useGetCharacter, useGetCharacterInventory, useGetCharacterVehicles } from "../../../../hooks/useGetAdmin";
import { hexToSteamId64 } from '../../../../utils/steam';
import InventoryItem from './components/InventoryItem';
import CharacterDivider from './components/CharacterDivider';
import { useNavigate } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';

const GET_CHARACTER = gql`
  query GetCharacter($id: ID!) {
    player(id: $id) {
      id
      citizenid
      name
      license
      charinfo
      money
      job
      gang
      position
      metadata
      inventory
    }
    inventory(id: $id) {
      name
      data
    }
    playerVehicles(id: $id) {
      plate
      vehicle
      vinnumber
      vinscratch
      drivingdistance
      body
      engine
      supporter
    }
  }
`;

function EditData({ type }) {
  return (
    <Button shape="circle" icon={<EditFilled />} onClick={() => console.log(type)} />
  );
}

function App() {
  const { id } = useParams();

  const navigate = useNavigate();

  const { data, error, loading: isFetching } = useQuery(GET_CHARACTER, {
    variables: { id: id }
  });

  const [character, setCharacterData] = useState([]);
  const [inventory, setInventoryData] = useState([]);
  const [vehicles, setVehiclesData] = useState([]);

  useEffect(() => {
    if (!isFetching && data) {
      if (data.player) {
        const res = data.player;
        const charinfo = JSON.parse(res.charinfo);
        const money = JSON.parse(res.money);
        const job = JSON.parse(res.job);
        const gang = JSON.parse(res.gang);
        const position = JSON.parse(res.position);
        const metadata = JSON.parse(res.metadata);
        const inventory = JSON.parse(res.inventory);

        const fixedData = {
          key: res.id,
          citizenid: res.citizenid,
          steamName: res.name,
          license: res.license,
          name: `${charinfo.firstname} ${charinfo.lastname}`,
          cash: money.cash,
          bank: money.bank,
          crypto: money.crypto,
          job: job,
          gang: gang,
          position: position,
          metadata: metadata,
          inventory: inventory,
        }

        setCharacterData(fixedData);
      }

      if (data.inventory) {
        setInventoryData(data.inventory);
      }

      if (data.playerVehicles) {
        setVehiclesData(data.playerVehicles);
      }
    }
  }, [data, isFetching]);

  const vehicleListColumns = [
    {
      title: 'Plate',
      dataIndex: 'plate',
    },
    {
      title: 'Vehicle',
      dataIndex: 'vehicle',
    },
    {
      title: 'Vin Number',
      dataIndex: 'vinnumber',
    },
    {
      title: 'Vin Scratch',
      dataIndex: 'vinscratch',
    },
    {
      title: 'Miles',
      dataIndex: 'drivingdistance',
    },
    {
      title: 'Body Health',
      dataIndex: 'body',
    },
    {
      title: 'Engine Health',
      dataIndex: 'engine',
    },
    {
      title: 'Supporter',
      dataIndex: 'supporter',
    },
  ];

  if (error) {
    return (
      <div>
        <h1>Error fetching character.</h1>
        <p>{error.message}</p>
      </div>
    );
  }

  if (isFetching) {
    return (
      <div>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <Space size="large" direction="vertical" style={{ width: '100%', marginBottom: '24px' }}>
      <h1>View character</h1>
      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="character_basics" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Character Details">
            <Descriptions.Item label="Character Name">{character.name}</Descriptions.Item>
            <Descriptions.Item label="Steam Name">{character.steamName}</Descriptions.Item>
            <Descriptions.Item label="License">{character.license}</Descriptions.Item>
            <Descriptions.Item label="Steam ID 64">{hexToSteamId64(character.license)}</Descriptions.Item>
            <Descriptions.Item label="Last position">{character.position?.x}, {character.position?.y}, {character.position?.z}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="money" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 }} layout="vertical" size="small" bordered title="Financial Status">
            <Descriptions.Item label="Cash">{character.cash}</Descriptions.Item>
            <Descriptions.Item label="Bank">{character.bank}</Descriptions.Item>
            <Descriptions.Item label="Crypto"><b>DEFAULT:</b> {character.crypto}, <b>LME:</b> {character.metadata?.crypto?.lme}, <b>XCOIN:</b> {character.metadata?.crypto?.xcoin}, <b>SHUNG:</b> {character.metadata?.crypto?.shung}, <b>GNE:</b> {character.metadata?.crypto?.gne}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={[{ xs: 5, sm: 5, md: 5, lg: 5 }, { xs: 5, sm: 5, md: 5, lg: 5 }]}>
        <Col span={24}>
          <Descriptions extra={<EditData type="inventory" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title="Inventory">
          </Descriptions>
        </Col>

        {character.inventory?.map((item, index) => (
          <Col key={index}>
            <InventoryItem item={item.name} amount={item.count} />
          </Col>
        ))}

        {error ? (
          <Col span={24}>
            <Descriptions extra={<EditData type="inventory" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title="Error fetching other inventory types for this character..">
            </Descriptions>
          </Col>
        ) : error ? (
          <Col span={24}>
            <Descriptions extra={<EditData type="inventory" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title="Loading...">
            </Descriptions>
          </Col>
        ) : (
          inventory?.map((item, index) => (
            <>
              <Col span={24} key={index}>
                <CharacterDivider />
                <Descriptions extra={<EditData type="inventory" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title={item.name}>
                </Descriptions>
              </Col>
              {JSON.parse(item.data)?.map((item, index) => (
                <Col key={index}>
                  <InventoryItem item={item.name} amount={item.count} />
                </Col>
              ))}
            </>
          ))
        )}
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="licenses" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 }} layout="vertical" size="small" bordered title="Licenses">
            <Descriptions.Item label="Plane">{character.metadata?.licences?.plane ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Permit">{character.metadata?.licences?.permit ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Driver">{character.metadata?.licences?.driver ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Weapon">{character.metadata?.licences?.weapon ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Helicopter">{character.metadata?.licences?.helicopter ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Motorcycle">{character.metadata?.licences?.motorcycle ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Business">{character.metadata?.licences?.business ? "Yes" : "No"}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="skills" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 }} layout="vertical" size="small" bordered title="Skills">
            <Descriptions.Item label="Hunting">{character.metadata?.skills?.hunting}</Descriptions.Item>
            <Descriptions.Item label="Crafting">{character.metadata?.skills?.crafting}</Descriptions.Item>
            <Descriptions.Item label="Smelting">{character.metadata?.skills?.smelting}</Descriptions.Item>
            <Descriptions.Item label="Chopshop">{character.metadata?.skills?.chopshop}</Descriptions.Item>
            <Descriptions.Item label="Drug sales">{character.metadata?.skills?.drugsales}</Descriptions.Item>
            <Descriptions.Item label="Garbage">{character.metadata?.skills?.garbage}</Descriptions.Item>
            <Descriptions.Item label="Towing">{character.metadata?.skills?.towing}</Descriptions.Item>
            <Descriptions.Item label="Mining">{character.metadata?.skills?.mining}</Descriptions.Item>
            <Descriptions.Item label="Diving">{character.metadata?.skills?.diving}</Descriptions.Item>
            <Descriptions.Item label="Dumpster diving">{character.metadata?.skills?.dumpsterdiving}</Descriptions.Item>
            <Descriptions.Item label="Fishing">{character.metadata?.skills?.fishing}</Descriptions.Item>
            <Descriptions.Item label="Trucking">{character.metadata?.skills?.trucking}</Descriptions.Item>
            <Descriptions.Item label="Taxi">{character.metadata?.skills?.taxi}</Descriptions.Item>
            <Descriptions.Item label="Cooking">{character.metadata?.skills?.cooking}</Descriptions.Item>
            <Descriptions.Item label="Thieving">{character.metadata?.skills?.thieving}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="metadata" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 }} layout="vertical" size="small" bordered title="Character data">
            <Descriptions.Item label="Dead">{character.metadata?.isdead ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Armor">{character.metadata?.armor}</Descriptions.Item>
            <Descriptions.Item label="In last stand?">{character.metadata?.inlaststand}</Descriptions.Item>
            <Descriptions.Item label="Escapee?">{character.metadata?.escaperecord?.escapee ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Blood type">{character.metadata?.bloodtype}</Descriptions.Item>
            <Descriptions.Item label="Boost class">{character.metadata?.carboostclass}</Descriptions.Item>
            <Descriptions.Item label="Boost reputation">{character.metadata?.carboostrep}</Descriptions.Item>
            <Descriptions.Item label="Tracker?">{character.metadata?.tracker ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Health">{character.metadata?.health}</Descriptions.Item>
            <Descriptions.Item label="Thirst">{character.metadata?.thirst}</Descriptions.Item>
            <Descriptions.Item label="Hunger">{character.metadata?.hunger}</Descriptions.Item>
            <Descriptions.Item label="Stress">{character.metadata?.stress}</Descriptions.Item>
            <Descriptions.Item label="Delivery">{character.metadata?.delivery}</Descriptions.Item>
            <Descriptions.Item label="Prison lifer?">{character.metadata?.prisonlifer ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="In jail?">{character.metadata?.injail ? "Yes" : "No"}</Descriptions.Item>
            <Descriptions.Item label="Call sign">{character.metadata?.callsign}</Descriptions.Item>
            <Descriptions.Item label="Fingerprint">{character.metadata?.fingerprint}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Table
            rowKey="id"
            columns={vehicleListColumns}
            dataSource={vehicles}
            loading={isFetching}
            size="small"
            onRow={(record, rowIndex) => {
              return {
                onClick: event => {
                  navigate(`/admin/vehicles/${record.plate}`);
                },
              };
            }}
          />
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="gang" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 3, xxl: 3 }} layout="vertical" size="small" bordered title="Gang affiliation">
            <Descriptions.Item label="Grade">{character.gang?.grade?.name}</Descriptions.Item>
            <Descriptions.Item label="Gang Label">{character.gang?.label}</Descriptions.Item>
            <Descriptions.Item label="Gang Name">{character.gang?.name}</Descriptions.Item>
            <Descriptions.Item label="Is boss?">{character.gang?.isboss ? "Yes" : "No"}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      {/* <pre>
        {JSON.stringify(character, null, 2)}
      </pre> */}
    </Space >
  );
}

export default App;
